// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Customers Page Layout */
.customers-wrapper {
  height: 100%;
  padding-top: 56px;
  padding-bottom: 64px;
  padding-left: 16px;
  padding-right: 16px;
  box-sizing: border-box;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  width: 100%;
  background: #f3f4f6;
}

.customers-container {
  display: grid;
  grid-template-columns: 1fr 0.65fr;
  flex: 1;
  min-height: 0;
  overflow: hidden;
  border-radius: 10px;
  box-shadow: 0 1px 4px rgba(0,0,0,0.08);
}

/* ── LEFT PANEL ── */
.customers-left {
  background: #ffffff;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border-right: 1px solid #e5e7eb;
}

.customers-left-inner {
  padding: 14px 20px 0 20px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  flex-shrink: 0;
  overflow: hidden;
}

/* Header */
.customers-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
}

.customers-header-left h2 {
  font-size: 22px;
  font-weight: 700;
  color: #111827;
  margin: 0 0 2px 0;
}

.customers-header-left p {
  font-size: 13px;
  color: #6b7280;
  margin: 0;
}

.customers-header-actions {
  display: flex;
  gap: 8px;
  align-items: center;
}

.btn-filter {
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 7px 13px;
  border: 1px solid #d1d5db;
  border-radius: 7px;
  background: #ffffff;
  color: #374151;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.15s;
}

.btn-filter:hover {
  background: #f9fafb;
}

.btn-download {
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 7px 13px;
  border: 1px solid #2563eb;
  border-radius: 7px;
  background: #2563eb;
  color: #ffffff;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.15s;
}

.btn-download:hover {
  background: #1d4ed8;
}

/* Search Bar */
.customers-search-wrapper {
  position: relative;
}

.customers-search-wrapper svg {
  position: absolute;
  left: 11px;
  top: 50%;
  transform: translateY(-50%);
  width: 16px;
  height: 16px;
  color: #9ca3af;
}

.customers-search {
  width: 100%;
  padding: 9px 12px 9px 36px;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  font-size: 13px;
  color: #374151;
  outline: none;
  box-sizing: border-box;
  transition: border-color 0.15s;
}

.customers-search:focus {
  border-color: #2563eb;
  box-shadow: 0 0 0 2px rgba(37, 99, 235, 0.1);
}

.customers-search::placeholder {
  color: #9ca3af;
}

/* Stat Cards */
.customers-stat-cards {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 10px;
}

.stat-card {
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 14px 14px 12px 14px;
  background: #ffffff;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.stat-card-top {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
}

.stat-card-label {
  font-size: 11px;
  color: #6b7280;
  font-weight: 500;
  line-height: 1.3;
}

.stat-card-icon {
  width: 28px;
  height: 28px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.stat-card-icon svg {
  width: 16px;
  height: 16px;
}

.stat-card-icon.blue {
  background: #dbeafe;
  color: #2563eb;
}

.stat-card-icon.green {
  background: #dcfce7;
  color: #166534;
}

.stat-card-icon.purple {
  background: #f3e8ff;
  color: #7e22ce;
}

.stat-card-icon.yellow {
  background: #fef9c3;
  color: #854d0e;
}

.stat-card-value {
  font-size: 20px;
  font-weight: 700;
  color: #111827;
  line-height: 1;
}

/* Filter Tabs */
.customers-filter-tabs {
  display: flex;
  gap: 8px;
}

.filter-tab {
  padding: 6px 16px;
  border-radius: 20px;
  border: 1px solid #e5e7eb;
  background: #ffffff;
  color: #6b7280;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.15s;
}

.filter-tab:hover {
  border-color: #93c5fd;
  color: #2563eb;
}

.filter-tab.active {
  border-color: #2563eb;
  color: #2563eb;
  background: #eff6ff;
}

/* Customer List */
.customers-list-scroll {
  flex: 1;
  overflow-y: auto;
  padding: 12px 20px 20px 20px;
  min-height: 0;
}

.customers-list-scroll::-webkit-scrollbar {
  width: 5px;
}

.customers-list-scroll::-webkit-scrollbar-thumb {
  background: #d1d5db;
  border-radius: 4px;
}

/* Customer Card */
.customer-card {
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 12px 16px;
  cursor: pointer;
  transition: all 0.15s;
  margin-bottom: 8px;
  background: #ffffff;
}

.customer-card:hover {
  border-color: #93c5fd;
  background: #f8faff;
}

.customer-card.selected {
  border-color: #2563eb;
  background: #eff6ff;
  box-shadow: 0 0 0 1px #2563eb;
}

.customer-card-top {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 7px;
}

.customer-avatar {
  width: 38px;
  height: 38px;
  border-radius: 50%;
  background: #2563eb;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  color: #ffffff;
}

.customer-avatar svg {
  width: 20px;
  height: 20px;
}

.customer-name-block {
  flex: 1;
  min-width: 0;
}

.customer-name-row {
  display: flex;
  align-items: center;
  gap: 7px;
  flex-wrap: wrap;
}

.customer-name {
  font-size: 14px;
  font-weight: 700;
  color: #111827;
}

.tier-badge {
  font-size: 10px;
  font-weight: 600;
  padding: 2px 8px;
  border-radius: 10px;
  letter-spacing: 0.02em;
}

.tier-badge.VIP {
  background: #dcfce7;
  color: #166534;
}

.tier-badge.Gold {
  background: #fef9c3;
  color: #854d0e;
}

.tier-badge.Silver {
  background: #f1f5f9;
  color: #475569;
}

.tier-badge.Bronze {
  background: #ffedd5;
  color: #9a3412;
}

.customer-contact {
  font-size: 12px;
  color: #6b7280;
  margin-top: 2px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.customer-stats-row {
  display: flex;
  gap: 16px;
  font-size: 12px;
  color: #374151;
  flex-wrap: wrap;
}

.customer-stats-row span {
  color: #6b7280;
}

.customer-last-visit {
  font-size: 11px;
  color: #9ca3af;
  margin-top: 4px;
}

/* ── RIGHT PANEL ── */
.customers-right {
  background: #f6f7f8;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  height: 100%;
  min-height: 0;
}

.customers-right::-webkit-scrollbar {
  width: 5px;
}

.customers-right::-webkit-scrollbar-thumb {
  background: #d1d5db;
  border-radius: 4px;
}

/* Empty state */
.customers-empty-state {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 40px;
}

.customers-empty-state svg {
  width: 64px;
  height: 64px;
  color: #d1d5db;
}

.customers-empty-state p {
  font-size: 15px;
  color: #9ca3af;
  font-weight: 500;
  margin: 0;
  text-align: center;
}

/* Detail Panel */
.customer-detail {
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 0;
}

.detail-card {
  background: #ffffff;
  border-radius: 10px;
  padding: 14px 16px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
  margin-bottom: 12px;
}

/* Profile header card */
.detail-profile-header {
  display: flex;
  align-items: center;
  gap: 12px;
}

.detail-avatar {
  width: 46px;
  height: 46px;
  border-radius: 50%;
  background: #2563eb;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  color: #ffffff;
}

.detail-avatar svg {
  width: 26px;
  height: 26px;
}

.detail-name-block {
  flex: 1;
  min-width: 0;
}

.detail-name {
  font-size: 16px;
  font-weight: 700;
  color: #111827;
  margin: 0 0 2px 0;
}

.detail-id {
  font-size: 12px;
  color: #9ca3af;
  margin: 0;
}

.detail-edit-btn {
  background: none;
  border: 1px solid #e5e7eb;
  border-radius: 7px;
  padding: 6px;
  cursor: pointer;
  color: #6b7280;
  display: flex;
  align-items: center;
  transition: background 0.15s;
}

.detail-edit-btn:hover {
  background: #f3f4f6;
  color: #374151;
}

.detail-edit-btn svg {
  width: 15px;
  height: 15px;
}

.detail-tier-row {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 10px;
  padding-top: 10px;
  border-top: 1px solid #f3f4f6;
}

.detail-since {
  font-size: 12px;
  color: #6b7280;
}

/* Section container (borderless, plain) */
.detail-section {
  margin-bottom: 4px;
  padding: 12px 0 8px;
  border-bottom: 1px solid #e5e7eb;
}

.detail-section:last-of-type {
  border-bottom: none;
}

.section-title {
  font-size: 14px;
  font-weight: 700;
  color: #111827;
  margin: 0 0 10px 0;
}

/* Contact rows */
.contact-row {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 6px 0;
}

.contact-icon {
  width: 34px;
  height: 34px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.contact-icon svg {
  width: 16px;
  height: 16px;
}

.contact-icon.phone-icon {
  background: #eff6ff;
  color: #2563eb;
}

.contact-icon.email-icon {
  background: #f0fdf4;
  color: #16a34a;
}

.contact-info {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 1px;
  min-width: 0;
}

.contact-label {
  font-size: 11px;
  color: #9ca3af;
}

.contact-value {
  font-size: 13px;
  font-weight: 600;
  color: #111827;
}

.contact-chat-btn {
  background: none;
  border: none;
  cursor: pointer;
  color: #9ca3af;
  display: flex;
  align-items: center;
  padding: 4px;
  border-radius: 6px;
  transition: color 0.15s;
}

.contact-chat-btn:hover {
  color: #2563eb;
}

.contact-chat-btn svg {
  width: 16px;
  height: 16px;
}

/* Special dates */
.special-date-row {
  display: flex;
  align-items: center;
  gap: 10px;
}

.date-icon {
  width: 34px;
  height: 34px;
  border-radius: 8px;
  background: #eff6ff;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  color: #2563eb;
}

.date-icon svg {
  width: 16px;
  height: 16px;
}

.date-label {
  font-size: 11px;
  color: #9ca3af;
}

.date-value {
  font-size: 13px;
  font-weight: 600;
  color: #111827;
}

/* Preferences */
.pref-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-bottom: 10px;
}

.pref-tag {
  font-size: 12px;
  padding: 3px 10px;
  border-radius: 12px;
  font-weight: 500;
  border: 1px solid transparent;
}

.pref-tag.dietary-non-vegetarian {
  background: #fef2f2;
  color: #dc2626;
  border-color: #fecaca;
}

.pref-tag.dietary-vegetarian {
  background: #f0fdf4;
  color: #16a34a;
  border-color: #bbf7d0;
}

.pref-tag.dietary-vegan {
  background: #f0fdf4;
  color: #16a34a;
  border-color: #bbf7d0;
}

.pref-subtitle {
  font-size: 12px;
  color: #374151;
  font-weight: 600;
  margin-bottom: 6px;
}

.favorites-list {
  display: flex;
  flex-direction: column;
  gap: 3px;
}

.favorite-item {
  font-size: 13px;
  color: #374151;
  padding: 1px 0;
}

/* Notes alert */
.notes-alert {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  background: #fffbeb;
  border: 1px solid #fde68a;
  border-radius: 8px;
  padding: 10px 12px;
}

.notes-alert-icon {
  font-size: 14px;
  color: #d97706;
  flex-shrink: 0;
  line-height: 1.4;
}

.notes-alert-text {
  font-size: 13px;
  color: #92400e;
  line-height: 1.5;
}

/* Statistics key-value */
.stats-kv-list {
  display: flex;
  flex-direction: column;
  gap: 0;
}

.stats-kv-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 0;
  border-bottom: 1px solid #f3f4f6;
  font-size: 13px;
}

.stats-kv-row:last-child {
  border-bottom: none;
}

.stats-kv-label {
  color: #6b7280;
}

.stats-kv-value {
  font-weight: 600;
  color: #111827;
}

/* Recent Orders */
.recent-orders-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.recent-order-card {
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 10px 12px;
  background: #ffffff;
}

.recent-order-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 4px;
}

.recent-order-id {
  font-size: 13px;
  font-weight: 600;
  color: #111827;
}

.order-type-badge {
  font-size: 11px;
  font-weight: 600;
  padding: 2px 9px;
  border-radius: 10px;
}

.order-type-dinein {
  background: #dcfce7;
  color: #166534;
}

.order-type-takeaway {
  background: #fef9c3;
  color: #854d0e;
}

.order-type-delivery {
  background: #dbeafe;
  color: #1d4ed8;
}

.recent-order-meta {
  font-size: 12px;
  color: #6b7280;
  display: flex;
  align-items: center;
  gap: 5px;
  margin-bottom: 6px;
}

.recent-order-dot {
  color: #d1d5db;
}

.recent-order-bottom {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.recent-order-items {
  font-size: 12px;
  color: #6b7280;
}

.recent-order-amount {
  font-size: 13px;
  font-weight: 700;
  color: #111827;
}

/* Action Buttons */
.detail-actions {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 16px 0 4px;
}

.btn-create-order {
  width: 100%;
  padding: 12px;
  background: #2563eb;
  color: #ffffff;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.15s;
}

.btn-create-order:hover {
  background: #1d4ed8;
}

.btn-add-points {
  width: 100%;
  padding: 11px;
  background: #ffffff;
  color: #2563eb;
  border: 1.5px solid #2563eb;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.15s;
}

.btn-add-points:hover {
  background: #eff6ff;
}

/* ═══ DARK THEME — Customers page ═══ */
.dark .customers-wrapper { background: #0f172a; }

.dark .customers-left {
  background: #1e293b;
  border-right-color: #334155;
}
.dark .customers-header-left h2 { color: #f1f5f9; }
.dark .customers-header-left p  { color: #94a3b8; }

.dark .btn-filter {
  background: #1e293b;
  border-color: #334155;
  color: #94a3b8;
}
.dark .btn-filter:hover { background: #334155; }

.dark .customers-search {
  background: #0f172a;
  border-color: #334155;
  color: #e2e8f0;
}
.dark .customers-search::placeholder { color: #475569; }
.dark .customers-search:focus { border-color: #2563eb; }

.dark .stat-card {
  background: #0f172a;
  border-color: #334155;
}
.dark .stat-card-label  { color: #64748b; }
.dark .stat-card-value  { color: #f1f5f9; }

.dark .filter-tab {
  background: #1e293b;
  border-color: #334155;
  color: #64748b;
}
.dark .filter-tab:hover { border-color: #3b82f6; color: #60a5fa; }
.dark .filter-tab.active { border-color: #2563eb; color: #60a5fa; background: rgba(37,99,235,0.1); }

.dark .customer-card {
  background: #1e293b;
  border-color: #334155;
}
.dark .customer-card:hover  { border-color: #3b82f6; background: #243043; }
.dark .customer-card.selected { border-color: #2563eb; background: rgba(37,99,235,0.1); }
.dark .customer-name         { color: #f1f5f9; }
.dark .customer-contact      { color: #64748b; }
.dark .customer-stats-row    { color: #94a3b8; }
.dark .customer-stats-row span { color: #64748b; }
.dark .customer-last-visit   { color: #475569; }

.dark .tier-badge.Silver { background: #1e293b; color: #94a3b8; }

.dark .customers-right { background: #0f172a; }
.dark .customers-right::-webkit-scrollbar-thumb { background: #334155; }

.dark .customers-empty-state svg { color: #334155; }
.dark .customers-empty-state p   { color: #64748b; }

.dark .detail-card {
  background: #1e293b;
  box-shadow: 0 1px 3px rgba(0,0,0,0.3);
}
.dark .detail-name   { color: #f1f5f9; }
.dark .detail-id     { color: #64748b; }
.dark .detail-edit-btn {
  border-color: #334155;
  color: #64748b;
}
.dark .detail-edit-btn:hover { background: #334155; color: #e2e8f0; }
.dark .detail-tier-row  { border-top-color: #334155; }
.dark .detail-since      { color: #64748b; }
.dark .detail-section    { border-bottom-color: #334155; }
.dark .section-title     { color: #f1f5f9; }

.dark .contact-value { color: #e2e8f0; }
.dark .contact-label { color: #64748b; }
.dark .date-value    { color: #e2e8f0; }
.dark .date-label    { color: #64748b; }
.dark .pref-subtitle { color: #94a3b8; }
.dark .favorite-item { color: #94a3b8; }

.dark .notes-alert { background: #451a03; border-color: #78350f; }
.dark .notes-alert-text { color: #fde68a; }

.dark .stats-kv-row  { border-bottom-color: #334155; }
.dark .stats-kv-label { color: #64748b; }
.dark .stats-kv-value { color: #f1f5f9; }

.dark .recent-order-card {
  background: #1e293b;
  border-color: #334155;
}
.dark .recent-order-id     { color: #f1f5f9; }
.dark .recent-order-meta   { color: #64748b; }
.dark .recent-order-items  { color: #64748b; }
.dark .recent-order-amount { color: #f1f5f9; }

.dark .btn-add-points {
  background: #0f172a;
  color: #60a5fa;
  border-color: #2563eb;
}
.dark .btn-add-points:hover { background: rgba(37,99,235,0.1); }

.dark .customers-list-scroll::-webkit-scrollbar-thumb { background: #334155; }
`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/customers/customers.css"],"names":[],"mappings":"AAAA,0BAA0B;AAC1B;EACE,YAAY;EACZ,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,iCAAiC;EACjC,OAAO;EACP,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA,qBAAqB;AACrB;EACE,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,cAAc;EACd,gBAAgB;AAClB;;AAEA,WAAW;AACX;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;AACX;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA,eAAe;AACf;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,0BAA0B;EAC1B,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,cAAc;AAChB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,4BAA4B;EAC5B,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,mBAAmB;AACrB;;AAEA,kBAAkB;AAClB;EACE,OAAO;EACP,gBAAgB;EAChB,4BAA4B;EAC5B,aAAa;AACf;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,kBAAkB;AAClB;EACE,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,OAAO;EACP,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA,sBAAsB;AACtB;EACE,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,gBAAgB;AAChB;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,SAAS;EACT,kBAAkB;AACpB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,MAAM;AACR;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,yCAAyC;EACzC,mBAAmB;AACrB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,OAAO;EACP,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,0CAA0C;AAC1C;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,sBAAsB;EACtB,MAAM;AACR;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,cAAc;EACd,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,2BAA2B;EAC3B,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA,wCAAwC;AACxC,2BAA2B,mBAAmB,EAAE;;AAEhD;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;AACA,kCAAkC,cAAc,EAAE;AAClD,kCAAkC,cAAc,EAAE;;AAElD;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;AACA,0BAA0B,mBAAmB,EAAE;;AAE/C;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;AACA,uCAAuC,cAAc,EAAE;AACvD,gCAAgC,qBAAqB,EAAE;;AAEvD;EACE,mBAAmB;EACnB,qBAAqB;AACvB;AACA,0BAA0B,cAAc,EAAE;AAC1C,0BAA0B,cAAc,EAAE;;AAE1C;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;AACA,0BAA0B,qBAAqB,EAAE,cAAc,EAAE;AACjE,2BAA2B,qBAAqB,EAAE,cAAc,EAAE,+BAA+B,EAAE;;AAEnG;EACE,mBAAmB;EACnB,qBAAqB;AACvB;AACA,8BAA8B,qBAAqB,EAAE,mBAAmB,EAAE;AAC1E,gCAAgC,qBAAqB,EAAE,+BAA+B,EAAE;AACxF,+BAA+B,cAAc,EAAE;AAC/C,+BAA+B,cAAc,EAAE;AAC/C,+BAA+B,cAAc,EAAE;AAC/C,iCAAiC,cAAc,EAAE;AACjD,+BAA+B,cAAc,EAAE;;AAE/C,2BAA2B,mBAAmB,EAAE,cAAc,EAAE;;AAEhE,yBAAyB,mBAAmB,EAAE;AAC9C,kDAAkD,mBAAmB,EAAE;;AAEvE,mCAAmC,cAAc,EAAE;AACnD,mCAAmC,cAAc,EAAE;;AAEnD;EACE,mBAAmB;EACnB,qCAAqC;AACvC;AACA,uBAAuB,cAAc,EAAE;AACvC,uBAAuB,cAAc,EAAE;AACvC;EACE,qBAAqB;EACrB,cAAc;AAChB;AACA,+BAA+B,mBAAmB,EAAE,cAAc,EAAE;AACpE,0BAA0B,yBAAyB,EAAE;AACrD,2BAA2B,cAAc,EAAE;AAC3C,2BAA2B,4BAA4B,EAAE;AACzD,2BAA2B,cAAc,EAAE;;AAE3C,uBAAuB,cAAc,EAAE;AACvC,uBAAuB,cAAc,EAAE;AACvC,uBAAuB,cAAc,EAAE;AACvC,uBAAuB,cAAc,EAAE;AACvC,uBAAuB,cAAc,EAAE;AACvC,uBAAuB,cAAc,EAAE;;AAEvC,qBAAqB,mBAAmB,EAAE,qBAAqB,EAAE;AACjE,0BAA0B,cAAc,EAAE;;AAE1C,uBAAuB,4BAA4B,EAAE;AACrD,wBAAwB,cAAc,EAAE;AACxC,wBAAwB,cAAc,EAAE;;AAExC;EACE,mBAAmB;EACnB,qBAAqB;AACvB;AACA,6BAA6B,cAAc,EAAE;AAC7C,6BAA6B,cAAc,EAAE;AAC7C,6BAA6B,cAAc,EAAE;AAC7C,6BAA6B,cAAc,EAAE;;AAE7C;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;AACA,8BAA8B,+BAA+B,EAAE;;AAE/D,wDAAwD,mBAAmB,EAAE","sourcesContent":["/* Customers Page Layout */\n.customers-wrapper {\n  height: 100%;\n  padding-top: 56px;\n  padding-bottom: 64px;\n  padding-left: 16px;\n  padding-right: 16px;\n  box-sizing: border-box;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  background: #f3f4f6;\n}\n\n.customers-container {\n  display: grid;\n  grid-template-columns: 1fr 0.65fr;\n  flex: 1;\n  min-height: 0;\n  overflow: hidden;\n  border-radius: 10px;\n  box-shadow: 0 1px 4px rgba(0,0,0,0.08);\n}\n\n/* ── LEFT PANEL ── */\n.customers-left {\n  background: #ffffff;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  border-right: 1px solid #e5e7eb;\n}\n\n.customers-left-inner {\n  padding: 14px 20px 0 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  flex-shrink: 0;\n  overflow: hidden;\n}\n\n/* Header */\n.customers-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n}\n\n.customers-header-left h2 {\n  font-size: 22px;\n  font-weight: 700;\n  color: #111827;\n  margin: 0 0 2px 0;\n}\n\n.customers-header-left p {\n  font-size: 13px;\n  color: #6b7280;\n  margin: 0;\n}\n\n.customers-header-actions {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n}\n\n.btn-filter {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  padding: 7px 13px;\n  border: 1px solid #d1d5db;\n  border-radius: 7px;\n  background: #ffffff;\n  color: #374151;\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background 0.15s;\n}\n\n.btn-filter:hover {\n  background: #f9fafb;\n}\n\n.btn-download {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  padding: 7px 13px;\n  border: 1px solid #2563eb;\n  border-radius: 7px;\n  background: #2563eb;\n  color: #ffffff;\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background 0.15s;\n}\n\n.btn-download:hover {\n  background: #1d4ed8;\n}\n\n/* Search Bar */\n.customers-search-wrapper {\n  position: relative;\n}\n\n.customers-search-wrapper svg {\n  position: absolute;\n  left: 11px;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 16px;\n  height: 16px;\n  color: #9ca3af;\n}\n\n.customers-search {\n  width: 100%;\n  padding: 9px 12px 9px 36px;\n  border: 1px solid #d1d5db;\n  border-radius: 8px;\n  font-size: 13px;\n  color: #374151;\n  outline: none;\n  box-sizing: border-box;\n  transition: border-color 0.15s;\n}\n\n.customers-search:focus {\n  border-color: #2563eb;\n  box-shadow: 0 0 0 2px rgba(37, 99, 235, 0.1);\n}\n\n.customers-search::placeholder {\n  color: #9ca3af;\n}\n\n/* Stat Cards */\n.customers-stat-cards {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 10px;\n}\n\n.stat-card {\n  border: 1px solid #e5e7eb;\n  border-radius: 8px;\n  padding: 14px 14px 12px 14px;\n  background: #ffffff;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.stat-card-top {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n}\n\n.stat-card-label {\n  font-size: 11px;\n  color: #6b7280;\n  font-weight: 500;\n  line-height: 1.3;\n}\n\n.stat-card-icon {\n  width: 28px;\n  height: 28px;\n  border-radius: 6px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.stat-card-icon svg {\n  width: 16px;\n  height: 16px;\n}\n\n.stat-card-icon.blue {\n  background: #dbeafe;\n  color: #2563eb;\n}\n\n.stat-card-icon.green {\n  background: #dcfce7;\n  color: #166534;\n}\n\n.stat-card-icon.purple {\n  background: #f3e8ff;\n  color: #7e22ce;\n}\n\n.stat-card-icon.yellow {\n  background: #fef9c3;\n  color: #854d0e;\n}\n\n.stat-card-value {\n  font-size: 20px;\n  font-weight: 700;\n  color: #111827;\n  line-height: 1;\n}\n\n/* Filter Tabs */\n.customers-filter-tabs {\n  display: flex;\n  gap: 8px;\n}\n\n.filter-tab {\n  padding: 6px 16px;\n  border-radius: 20px;\n  border: 1px solid #e5e7eb;\n  background: #ffffff;\n  color: #6b7280;\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.15s;\n}\n\n.filter-tab:hover {\n  border-color: #93c5fd;\n  color: #2563eb;\n}\n\n.filter-tab.active {\n  border-color: #2563eb;\n  color: #2563eb;\n  background: #eff6ff;\n}\n\n/* Customer List */\n.customers-list-scroll {\n  flex: 1;\n  overflow-y: auto;\n  padding: 12px 20px 20px 20px;\n  min-height: 0;\n}\n\n.customers-list-scroll::-webkit-scrollbar {\n  width: 5px;\n}\n\n.customers-list-scroll::-webkit-scrollbar-thumb {\n  background: #d1d5db;\n  border-radius: 4px;\n}\n\n/* Customer Card */\n.customer-card {\n  border: 1px solid #e5e7eb;\n  border-radius: 8px;\n  padding: 12px 16px;\n  cursor: pointer;\n  transition: all 0.15s;\n  margin-bottom: 8px;\n  background: #ffffff;\n}\n\n.customer-card:hover {\n  border-color: #93c5fd;\n  background: #f8faff;\n}\n\n.customer-card.selected {\n  border-color: #2563eb;\n  background: #eff6ff;\n  box-shadow: 0 0 0 1px #2563eb;\n}\n\n.customer-card-top {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 7px;\n}\n\n.customer-avatar {\n  width: 38px;\n  height: 38px;\n  border-radius: 50%;\n  background: #2563eb;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  color: #ffffff;\n}\n\n.customer-avatar svg {\n  width: 20px;\n  height: 20px;\n}\n\n.customer-name-block {\n  flex: 1;\n  min-width: 0;\n}\n\n.customer-name-row {\n  display: flex;\n  align-items: center;\n  gap: 7px;\n  flex-wrap: wrap;\n}\n\n.customer-name {\n  font-size: 14px;\n  font-weight: 700;\n  color: #111827;\n}\n\n.tier-badge {\n  font-size: 10px;\n  font-weight: 600;\n  padding: 2px 8px;\n  border-radius: 10px;\n  letter-spacing: 0.02em;\n}\n\n.tier-badge.VIP {\n  background: #dcfce7;\n  color: #166534;\n}\n\n.tier-badge.Gold {\n  background: #fef9c3;\n  color: #854d0e;\n}\n\n.tier-badge.Silver {\n  background: #f1f5f9;\n  color: #475569;\n}\n\n.tier-badge.Bronze {\n  background: #ffedd5;\n  color: #9a3412;\n}\n\n.customer-contact {\n  font-size: 12px;\n  color: #6b7280;\n  margin-top: 2px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.customer-stats-row {\n  display: flex;\n  gap: 16px;\n  font-size: 12px;\n  color: #374151;\n  flex-wrap: wrap;\n}\n\n.customer-stats-row span {\n  color: #6b7280;\n}\n\n.customer-last-visit {\n  font-size: 11px;\n  color: #9ca3af;\n  margin-top: 4px;\n}\n\n/* ── RIGHT PANEL ── */\n.customers-right {\n  background: #f6f7f8;\n  display: flex;\n  flex-direction: column;\n  overflow-y: auto;\n  height: 100%;\n  min-height: 0;\n}\n\n.customers-right::-webkit-scrollbar {\n  width: 5px;\n}\n\n.customers-right::-webkit-scrollbar-thumb {\n  background: #d1d5db;\n  border-radius: 4px;\n}\n\n/* Empty state */\n.customers-empty-state {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n  padding: 40px;\n}\n\n.customers-empty-state svg {\n  width: 64px;\n  height: 64px;\n  color: #d1d5db;\n}\n\n.customers-empty-state p {\n  font-size: 15px;\n  color: #9ca3af;\n  font-weight: 500;\n  margin: 0;\n  text-align: center;\n}\n\n/* Detail Panel */\n.customer-detail {\n  padding: 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n}\n\n.detail-card {\n  background: #ffffff;\n  border-radius: 10px;\n  padding: 14px 16px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);\n  margin-bottom: 12px;\n}\n\n/* Profile header card */\n.detail-profile-header {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.detail-avatar {\n  width: 46px;\n  height: 46px;\n  border-radius: 50%;\n  background: #2563eb;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  color: #ffffff;\n}\n\n.detail-avatar svg {\n  width: 26px;\n  height: 26px;\n}\n\n.detail-name-block {\n  flex: 1;\n  min-width: 0;\n}\n\n.detail-name {\n  font-size: 16px;\n  font-weight: 700;\n  color: #111827;\n  margin: 0 0 2px 0;\n}\n\n.detail-id {\n  font-size: 12px;\n  color: #9ca3af;\n  margin: 0;\n}\n\n.detail-edit-btn {\n  background: none;\n  border: 1px solid #e5e7eb;\n  border-radius: 7px;\n  padding: 6px;\n  cursor: pointer;\n  color: #6b7280;\n  display: flex;\n  align-items: center;\n  transition: background 0.15s;\n}\n\n.detail-edit-btn:hover {\n  background: #f3f4f6;\n  color: #374151;\n}\n\n.detail-edit-btn svg {\n  width: 15px;\n  height: 15px;\n}\n\n.detail-tier-row {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-top: 10px;\n  padding-top: 10px;\n  border-top: 1px solid #f3f4f6;\n}\n\n.detail-since {\n  font-size: 12px;\n  color: #6b7280;\n}\n\n/* Section container (borderless, plain) */\n.detail-section {\n  margin-bottom: 4px;\n  padding: 12px 0 8px;\n  border-bottom: 1px solid #e5e7eb;\n}\n\n.detail-section:last-of-type {\n  border-bottom: none;\n}\n\n.section-title {\n  font-size: 14px;\n  font-weight: 700;\n  color: #111827;\n  margin: 0 0 10px 0;\n}\n\n/* Contact rows */\n.contact-row {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 6px 0;\n}\n\n.contact-icon {\n  width: 34px;\n  height: 34px;\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.contact-icon svg {\n  width: 16px;\n  height: 16px;\n}\n\n.contact-icon.phone-icon {\n  background: #eff6ff;\n  color: #2563eb;\n}\n\n.contact-icon.email-icon {\n  background: #f0fdf4;\n  color: #16a34a;\n}\n\n.contact-info {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 1px;\n  min-width: 0;\n}\n\n.contact-label {\n  font-size: 11px;\n  color: #9ca3af;\n}\n\n.contact-value {\n  font-size: 13px;\n  font-weight: 600;\n  color: #111827;\n}\n\n.contact-chat-btn {\n  background: none;\n  border: none;\n  cursor: pointer;\n  color: #9ca3af;\n  display: flex;\n  align-items: center;\n  padding: 4px;\n  border-radius: 6px;\n  transition: color 0.15s;\n}\n\n.contact-chat-btn:hover {\n  color: #2563eb;\n}\n\n.contact-chat-btn svg {\n  width: 16px;\n  height: 16px;\n}\n\n/* Special dates */\n.special-date-row {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.date-icon {\n  width: 34px;\n  height: 34px;\n  border-radius: 8px;\n  background: #eff6ff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  color: #2563eb;\n}\n\n.date-icon svg {\n  width: 16px;\n  height: 16px;\n}\n\n.date-label {\n  font-size: 11px;\n  color: #9ca3af;\n}\n\n.date-value {\n  font-size: 13px;\n  font-weight: 600;\n  color: #111827;\n}\n\n/* Preferences */\n.pref-tags {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  margin-bottom: 10px;\n}\n\n.pref-tag {\n  font-size: 12px;\n  padding: 3px 10px;\n  border-radius: 12px;\n  font-weight: 500;\n  border: 1px solid transparent;\n}\n\n.pref-tag.dietary-non-vegetarian {\n  background: #fef2f2;\n  color: #dc2626;\n  border-color: #fecaca;\n}\n\n.pref-tag.dietary-vegetarian {\n  background: #f0fdf4;\n  color: #16a34a;\n  border-color: #bbf7d0;\n}\n\n.pref-tag.dietary-vegan {\n  background: #f0fdf4;\n  color: #16a34a;\n  border-color: #bbf7d0;\n}\n\n.pref-subtitle {\n  font-size: 12px;\n  color: #374151;\n  font-weight: 600;\n  margin-bottom: 6px;\n}\n\n.favorites-list {\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n}\n\n.favorite-item {\n  font-size: 13px;\n  color: #374151;\n  padding: 1px 0;\n}\n\n/* Notes alert */\n.notes-alert {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n  background: #fffbeb;\n  border: 1px solid #fde68a;\n  border-radius: 8px;\n  padding: 10px 12px;\n}\n\n.notes-alert-icon {\n  font-size: 14px;\n  color: #d97706;\n  flex-shrink: 0;\n  line-height: 1.4;\n}\n\n.notes-alert-text {\n  font-size: 13px;\n  color: #92400e;\n  line-height: 1.5;\n}\n\n/* Statistics key-value */\n.stats-kv-list {\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n}\n\n.stats-kv-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 8px 0;\n  border-bottom: 1px solid #f3f4f6;\n  font-size: 13px;\n}\n\n.stats-kv-row:last-child {\n  border-bottom: none;\n}\n\n.stats-kv-label {\n  color: #6b7280;\n}\n\n.stats-kv-value {\n  font-weight: 600;\n  color: #111827;\n}\n\n/* Recent Orders */\n.recent-orders-list {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.recent-order-card {\n  border: 1px solid #e5e7eb;\n  border-radius: 8px;\n  padding: 10px 12px;\n  background: #ffffff;\n}\n\n.recent-order-top {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 4px;\n}\n\n.recent-order-id {\n  font-size: 13px;\n  font-weight: 600;\n  color: #111827;\n}\n\n.order-type-badge {\n  font-size: 11px;\n  font-weight: 600;\n  padding: 2px 9px;\n  border-radius: 10px;\n}\n\n.order-type-dinein {\n  background: #dcfce7;\n  color: #166534;\n}\n\n.order-type-takeaway {\n  background: #fef9c3;\n  color: #854d0e;\n}\n\n.order-type-delivery {\n  background: #dbeafe;\n  color: #1d4ed8;\n}\n\n.recent-order-meta {\n  font-size: 12px;\n  color: #6b7280;\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  margin-bottom: 6px;\n}\n\n.recent-order-dot {\n  color: #d1d5db;\n}\n\n.recent-order-bottom {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.recent-order-items {\n  font-size: 12px;\n  color: #6b7280;\n}\n\n.recent-order-amount {\n  font-size: 13px;\n  font-weight: 700;\n  color: #111827;\n}\n\n/* Action Buttons */\n.detail-actions {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  padding: 16px 0 4px;\n}\n\n.btn-create-order {\n  width: 100%;\n  padding: 12px;\n  background: #2563eb;\n  color: #ffffff;\n  border: none;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background 0.15s;\n}\n\n.btn-create-order:hover {\n  background: #1d4ed8;\n}\n\n.btn-add-points {\n  width: 100%;\n  padding: 11px;\n  background: #ffffff;\n  color: #2563eb;\n  border: 1.5px solid #2563eb;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background 0.15s;\n}\n\n.btn-add-points:hover {\n  background: #eff6ff;\n}\n\n/* ═══ DARK THEME — Customers page ═══ */\n.dark .customers-wrapper { background: #0f172a; }\n\n.dark .customers-left {\n  background: #1e293b;\n  border-right-color: #334155;\n}\n.dark .customers-header-left h2 { color: #f1f5f9; }\n.dark .customers-header-left p  { color: #94a3b8; }\n\n.dark .btn-filter {\n  background: #1e293b;\n  border-color: #334155;\n  color: #94a3b8;\n}\n.dark .btn-filter:hover { background: #334155; }\n\n.dark .customers-search {\n  background: #0f172a;\n  border-color: #334155;\n  color: #e2e8f0;\n}\n.dark .customers-search::placeholder { color: #475569; }\n.dark .customers-search:focus { border-color: #2563eb; }\n\n.dark .stat-card {\n  background: #0f172a;\n  border-color: #334155;\n}\n.dark .stat-card-label  { color: #64748b; }\n.dark .stat-card-value  { color: #f1f5f9; }\n\n.dark .filter-tab {\n  background: #1e293b;\n  border-color: #334155;\n  color: #64748b;\n}\n.dark .filter-tab:hover { border-color: #3b82f6; color: #60a5fa; }\n.dark .filter-tab.active { border-color: #2563eb; color: #60a5fa; background: rgba(37,99,235,0.1); }\n\n.dark .customer-card {\n  background: #1e293b;\n  border-color: #334155;\n}\n.dark .customer-card:hover  { border-color: #3b82f6; background: #243043; }\n.dark .customer-card.selected { border-color: #2563eb; background: rgba(37,99,235,0.1); }\n.dark .customer-name         { color: #f1f5f9; }\n.dark .customer-contact      { color: #64748b; }\n.dark .customer-stats-row    { color: #94a3b8; }\n.dark .customer-stats-row span { color: #64748b; }\n.dark .customer-last-visit   { color: #475569; }\n\n.dark .tier-badge.Silver { background: #1e293b; color: #94a3b8; }\n\n.dark .customers-right { background: #0f172a; }\n.dark .customers-right::-webkit-scrollbar-thumb { background: #334155; }\n\n.dark .customers-empty-state svg { color: #334155; }\n.dark .customers-empty-state p   { color: #64748b; }\n\n.dark .detail-card {\n  background: #1e293b;\n  box-shadow: 0 1px 3px rgba(0,0,0,0.3);\n}\n.dark .detail-name   { color: #f1f5f9; }\n.dark .detail-id     { color: #64748b; }\n.dark .detail-edit-btn {\n  border-color: #334155;\n  color: #64748b;\n}\n.dark .detail-edit-btn:hover { background: #334155; color: #e2e8f0; }\n.dark .detail-tier-row  { border-top-color: #334155; }\n.dark .detail-since      { color: #64748b; }\n.dark .detail-section    { border-bottom-color: #334155; }\n.dark .section-title     { color: #f1f5f9; }\n\n.dark .contact-value { color: #e2e8f0; }\n.dark .contact-label { color: #64748b; }\n.dark .date-value    { color: #e2e8f0; }\n.dark .date-label    { color: #64748b; }\n.dark .pref-subtitle { color: #94a3b8; }\n.dark .favorite-item { color: #94a3b8; }\n\n.dark .notes-alert { background: #451a03; border-color: #78350f; }\n.dark .notes-alert-text { color: #fde68a; }\n\n.dark .stats-kv-row  { border-bottom-color: #334155; }\n.dark .stats-kv-label { color: #64748b; }\n.dark .stats-kv-value { color: #f1f5f9; }\n\n.dark .recent-order-card {\n  background: #1e293b;\n  border-color: #334155;\n}\n.dark .recent-order-id     { color: #f1f5f9; }\n.dark .recent-order-meta   { color: #64748b; }\n.dark .recent-order-items  { color: #64748b; }\n.dark .recent-order-amount { color: #f1f5f9; }\n\n.dark .btn-add-points {\n  background: #0f172a;\n  color: #60a5fa;\n  border-color: #2563eb;\n}\n.dark .btn-add-points:hover { background: rgba(37,99,235,0.1); }\n\n.dark .customers-list-scroll::-webkit-scrollbar-thumb { background: #334155; }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
